/**
 * Consistent styling for the New Ticket form
 * Matches the modern UI design implemented in the CategorizedFields component
 */

// Use theme token so it stays in sync with palette
export const headerColor = 'secondary.main';

export const headerStyle = {
  backgroundColor: headerColor,
  color: '#fff',
  padding: '12px 20px',
  fontSize: '0.95rem',
  fontWeight: 600,
  letterSpacing: '0.2px',
  borderTopLeftRadius: '10px',
  borderTopRightRadius: '10px'
};

export const cardStyle = {
  marginBottom: '16px',
  border: '1px solid #E5E7EB', // divider tone
  borderRadius: '10px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
  overflow: 'hidden',
  backgroundColor: '#FFFFFF'
};

export const cardContentStyle = {
  padding: '20px'
};

// Secondary header style for sub-sections (Employee Information, Service Fields)
export const secondaryHeaderStyle = {
  backgroundColor: '#f5f5f5',
  color: '#424242',
  padding: '10px 16px',
  fontSize: '0.85rem',
  fontWeight: 600,
  letterSpacing: '0.2px',
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
  borderBottom: '1px solid #e0e0e0',
};

export const secondaryCardStyle = {
  marginBottom: '12px',
  marginTop: '16px',
  border: '1px solid #e0e0e0',
  borderRadius: '8px',
  boxShadow: 'none',
  overflow: 'hidden',
  backgroundColor: '#fafafa',
};

// Sticky footer for charges and submit button
export const stickyFooterStyle = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: '#fff',
  borderTop: '1px solid #e0e0e0',
  boxShadow: '0 -4px 12px rgba(0,0,0,0.08)',
  padding: '16px 24px',
  zIndex: 1200,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '24px',
};

export const chargeItemStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '0 16px',
  borderRight: '1px solid #e0e0e0',
  '&:last-child': {
    borderRight: 'none',
  },
};

export const totalSectionStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '24px',
  marginLeft: 'auto',
};

export default {
  headerColor,
  headerStyle,
  cardStyle,
  cardContentStyle,
  stickyFooterStyle,
  chargeItemStyle,
  totalSectionStyle,
  secondaryHeaderStyle,
  secondaryCardStyle,
};
